module.exports = __webpack_public_path__ + "static/img/logo.eecb62c6.png";